//Hooks
import { get } from 'svelte/store';
//Formating
import { format } from 'svelte-i18n';
//Helper
import { digitFormat, getTimeFormat, timeFormatUS } from 'src/helpers/date_helper';
//Types
import type { ScheduleParams, ScheduleRequestData } from 'src/types/requests/schedules/schedules_g2';
import type { LabelProps } from '@Shelly/shelly-design-system';
import { buildActionsLabels } from '../../local/ui/local_actions_view_helpers';

export const buildScheduleLabels = (
	schedule: ScheduleParams,
	deviceID: string,
	deviceChannels = 1,
): LabelProps[] => {
	const $format = get(format),
		type = schedule.enable ? 'default' : 'disabled',
		labelList: LabelProps[] = buildActionsLabels(schedule.calls, deviceID, deviceChannels);
	let hour = schedule.hour || 0,
		min = schedule.min || 0,
		inc = '';
	if (/sunrise|sunset/.test(schedule.type)) {
		hour = schedule.sunHour;
		min = schedule.sunMin;
		inc = schedule.inc;
		const title = $format(`schedule_opt_${schedule.type}`, {
			default: schedule.type,
		});
		labelList.push({
			value: title.toLowerCase(),
			icon: `fas fa-${schedule.type}`,
			type,
		});
	}
	if (
		/time/i.test(schedule.type) ||
		hour ||
		min ||
		(schedule.type == 'advancedTime' && !schedule.seconds.any)
	) {
		const label: LabelProps = {
			value:
				schedule.type == 'advancedTime'
					? ''
					: /sunrise|sunset/.test(schedule.type)
						? `${inc}${digitFormat(hour)}:${digitFormat(min)}`
						: getTimeFormat(hour, min),
			icon: `fas fa-${schedule.type == 'advancedTime' ? 'calendar-' : ''}clock`,
			type,
		};
		if (
			schedule.type == 'advancedTime' &&
			schedule.hours.values.length == 1 &&
			schedule.minutes.values.length == 1 &&
			schedule.seconds.values.length == 1
		) {
			label.value = `${inc}${getTimeFormat(hour, min)}`;
			const seconds = `:${digitFormat(schedule.seconds.values[0])}`;
			if (timeFormatUS()) {
				label.value = label.value.replace(/(\s*(A|P)M)$/, `${seconds}$1`);
			} else {
				label.value += seconds;
			}
			label.icon = 'fas fa-clock';
		}
		labelList.push(label);
	}
	if (!schedule.dates.any || !schedule.months.any) {
		labelList.push({
			value: '',
			icon: 'fas fa-calendar-days',
			type,
		});
	}
	return labelList;
};

export const buildUnsupportedLabels = (
	schedule: ScheduleRequestData,
	deviceID: string,
	deviceChannels = 1,
): LabelProps[] => {
	const $format = get(format),
		labelList: LabelProps[] = buildActionsLabels(schedule.calls, deviceID, deviceChannels);
	labelList.unshift({
		value: `id: ${schedule.id}`,
	});
	labelList.unshift({
		value: $format(`schedule_action_unsupported`, { default: 'Unsupported' }),
		icon: 'fas fa-triangle-exclamation',
		iconColor: '--color-warning',
	});
	return labelList;
};
